export const NIVEAUX_ETUDE = [
  { value: 'licence', label: 'Licence (Bac + 3) ou équivalent' },
  { value: 'master', label: 'Master (Bac + 5) ou équivalent' },
  { value: 'doctorat', label: 'Doctorat' },
];

// Critère 1 : seuls les diplômes de statisticien ou de démographe sont éligibles.
// "autre" n'existe que côté formulaire pour signaler l'inéligibilité au candidat.
export const DOMAINES_FORMATION = [
  { value: 'statistique', label: 'Statistique' },
  { value: 'demographie', label: 'Démographie' },
  { value: 'autre', label: 'Autre domaine' },
];

export const ROLES_ENQUETE = [
  { value: 'collecte', label: 'Agent enquêteur / collecte' },
  { value: 'supervision', label: "Superviseur / chef d'équipe" },
  { value: 'coordination', label: 'Coordonnateur (régional, provincial ou central)' },
];

export const OPERATIONS = [
  { value: 'ecv', label: 'Enquête Couverture Vaccinale (ECV)' },
  { value: 'eds', label: 'EDS' },
  { value: 'mics', label: 'MICS' },
  { value: 'sante_autre', label: 'Autre enquête de santé / vaccination' },
  { value: 'ecosit', label: 'ECOSIT' },
  { value: 'rsu_pmt', label: 'RSU/PMT' },
  { value: 'ecapp', label: 'ECAPP' },
  { value: 'autres', label: 'Autres enquêtes auprès des ménages' },
];

export const OUTILS_COLLECTE = [
  { value: 'survey_solutions', label: 'Survey Solutions' },
  { value: 'cspro', label: 'CSPro' },
  { value: 'kobocollect', label: 'KoboCollect' },
  { value: 'odk', label: 'ODK' },
  { value: 'autre', label: 'Autre outil similaire' },
];

export const STATUTS = [
  { value: 'soumise', label: 'Soumise', color: '#6b7280' },
  { value: 'en_examen', label: 'En examen', color: '#f59e0b' },
  { value: 'preselectionne', label: 'Présélectionné(e)', color: '#3b82f6' },
  { value: 'rejete', label: 'Rejeté(e)', color: '#ef4444' },
  { value: 'convoque_test', label: 'Convoqué(e) au test', color: '#8b5cf6' },
  { value: 'retenu', label: 'Retenu(e)', color: '#10b981' },
  { value: 'liste_reserve', label: 'Liste de réserve', color: '#f97316' },
];

export const CATEGORIES_SCORE = [
  { value: 'prioritaire', label: 'Prioritaire (80-100)', color: '#10b981' },
  { value: 'moyen', label: 'Moyen (50-79)', color: '#f59e0b' },
  { value: 'a_revoir', label: 'À revoir (<50)', color: '#ef4444' },
];
